import { getChannelEntryId, getListingChannelId, matchesChannelId } from './channelHelpers';
import { findListingEntity, findListingVariantEntity } from './entityReadHelpers';

export const resolveListingVariantFetchParamsByMaster = (productsState, channelId, masterVariantId) => {
  if (!productsState || !channelId || !masterVariantId) return null;

  const channelEntry = findListingVariantEntity(productsState, masterVariantId, channelId);

  if (!channelEntry?._id) return null;

  return {
    channelId,
    masterVariantId: String(masterVariantId),
    linkVariantId: String(channelEntry._id),
  };
};

export const resolveListingVariantFetchParamsByListingVariant = (productsState, listingId, listingVariantId) => {
  if (!productsState || !listingId || !listingVariantId) return null;

  const listing = findListingEntity(productsState, { listingProductId: listingId });
  const channelId = getListingChannelId(listing);
  if (!channelId) return null;

  const listingVariant = productsState.entities?.listingVariants?.[listingVariantId];
  const masterVariantId = listingVariant?.masterVariantId;

  if (!masterVariantId) return null;

  return {
    channelId,
    masterVariantId: String(masterVariantId),
    linkVariantId: String(listingVariantId),
  };
};

export const resolveListingVariantFetchParams = ({
  productsState,
  channelId,
  masterVariantId,
  listingId,
  listingVariantId,
}) => {
  if (channelId && masterVariantId) {
    return resolveListingVariantFetchParamsByMaster(productsState, channelId, masterVariantId);
  }

  if (listingId && listingVariantId) {
    return resolveListingVariantFetchParamsByListingVariant(productsState, listingId, listingVariantId);
  }

  return null;
};

export const listListingVariantFetchParamsForChannel = (productsState, channelId) => {
  if (!productsState || !channelId) return [];

  const product = productsState.items?.[0];
  const masterProduct = productsState.items?.find(({ variants }) => (
    (variants || []).some(({ _id }) => findListingVariantEntity(productsState, _id, channelId))
  )) || product;

  if (!masterProduct) {
    return Object.values(productsState.entities?.listingVariants || {})
      .filter((listingVariant) => matchesChannelId(listingVariant, channelId))
      .map((listingVariant) => ({
        channelId,
        masterVariantId: String(listingVariant.masterVariantId),
        linkVariantId: String(listingVariant._id),
      }));
  }

  return (masterProduct.variants || []).reduce((acc, masterVariant) => {
    const params = resolveListingVariantFetchParamsByMaster(
      productsState,
      channelId,
      masterVariant._id,
    );

    if (params) acc.push(params);
    return acc;
  }, []);
};

export default resolveListingVariantFetchParams;
